import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { HOME } from 'utils/routes';

const NavItem = ({ link, isFooterLink }) => {
  const renderNavItem = (
    <div className="flex items-center gap-4">
      {link.customIcon && link.customIcon}
      {link.Icon && <link.Icon className="w-4 h-4 fill-current text-grey-3" />}
      <div className="font-bold leading-5 font-primary text-4 text-dark -tracking-0.6">{link?.label}</div>
    </div>
  );

  const renderNavFooterItem = (
    <div className="flex items-center justify-between">
      <div className="leading-4 text-4 -tracking-0.2 text-dark">{link?.label}</div>
      {link.customIcon && link.customIcon}
      {link.Icon && <link.Icon className="w-3 h-3 text-black fill-current" />}
    </div>
  );

  if (link.forSeo) {
    return (
      <a
        id={`navbar-menu-${link?.id}`}
        href={link?.href || HOME}
        target="_blank"
        rel="noopener noreferrer"
        onClick={link?.onClick}
      >
        {isFooterLink ? renderNavFooterItem : renderNavItem}
      </a>
    );
  }

  return (
    <Link
      id={`navbar-menu-${link?.id}`}
      to={link?.href}
      onClick={link?.onClick}
    >
      {isFooterLink ? renderNavFooterItem : renderNavItem}
    </Link>
  );
};

NavItem.defaultProps = {
  link: {},
  isFooterLink: false,
};

NavItem.propTypes = {
  link: PropTypes.object,
  isFooterLink: PropTypes.bool,
};
export default NavItem;
